import PropTypes from "prop-types"
import { formatLongDate } from "helpers/formatters/dates"
import { PERIOD_SELECTOR_LABELS } from "helpers/shapes"

const DEFAULT_LABELS = {
  from: "Performance From",
  to: "As Of",
}

export default function PeriodDisplay({
  startDate,
  endDate,
  datesWithLabels,
  labels = DEFAULT_LABELS,
}) {
  if (datesWithLabels) {
    return (
      <>
        <div className="dates performance">
          <div className="date-label">{labels.from}</div>
          <span>{formatLongDate(startDate)}</span>
        </div>
        <div className="dates-separator">-</div>
        <div className="dates">
          <div className="date-label">{labels.to}</div>
          <span>{formatLongDate(endDate)}</span>
        </div>
      </>
    )
  }

  return (
    <span>{`${formatLongDate(startDate)} to ${formatLongDate(endDate)}`}</span>
  )
}

PeriodDisplay.propTypes = {
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
  datesWithLabels: PropTypes.bool,
  labels: PERIOD_SELECTOR_LABELS,
}
